import React, { useState } from 'react';
import { useAutoFix } from '../../context/AutoFixContext';
import { Code, Play, AlertTriangle } from 'lucide-react';
import { diagnosticEngine } from '../../agent/DiagnosticEngine';

export const CustomPlayground: React.FC = () => {
  const [customCode, setCustomCode] = useState(`function calculateShipping(cart) {
  // HIDDEN BUG: Returns undefined instead of 0 if cart is empty,
  // causing NaN when added to the total downstream.
  if (cart.length === 0) return; 
  return cart.length * 5.99;
}`);
  const [customError, setCustomError] = useState('TypeError: Cannot read properties of undefined (reading "toFixed")');
  
  const { setAgentMode } = useAutoFix();

  const handleInject = () => {
    // Ensure LLM mode is active for custom bugs
    setAgentMode('llm');

    // Manually trigger the diagnostic engine with a custom crash dump payload
    diagnosticEngine.healIncident('custom-bug', {
      errorMessage: customError,
      errorType: 'Unhandled Rejection',
      componentTree: ['TargetApp', 'CustomPlayground', 'InjectedComponent'],
      stackTrace: `Error: ${customError}\n    at calculateShipping (<anonymous>:4:22)\n    at render (<anonymous>:12:9)`,
      userAction: 'User clicked "Calculate Total"',
      stateSnapshot: {
        injectedCode: customCode,
        isCustomBug: true
      }
    });
  };

  return (
    <div className="card" style={{ marginTop: 12, padding: 12, borderLeft: '3px solid var(--accent)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8 }}>
        <Code size={14} style={{ color: 'var(--accent)' }} />
        <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-1)' }}>
          Custom Code Playground (Unknown Bug Test)
        </span>
      </div>
      
      <div style={{ fontSize: 11, color: 'var(--text-2)', marginBottom: 8 }}>
        Paste any buggy React component or JavaScript logic here. The Multi-Agent pipeline will use Gemini to dynamically analyze and patch it in real-time.
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <textarea
          value={customCode}
          onChange={(e) => setCustomCode(e.target.value)}
          style={{
            width: '100%',
            height: '80px',
            background: 'var(--bg-app)',
            border: '1px solid var(--border)',
            borderRadius: 'var(--radius-sm)',
            padding: 8,
            fontFamily: 'var(--font-mono)',
            fontSize: 10,
            color: 'var(--text-1)',
            resize: 'vertical'
          }}
          spellCheck={false}
        />
        
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 11, color: 'var(--text-3)', width: 80 }}>Crash Error:</span>
          <input 
            type="text" 
            value={customError}
            onChange={(e) => setCustomError(e.target.value)}
            style={{
              flex: 1,
              background: 'var(--bg-app)',
              border: '1px solid var(--border)',
              borderRadius: 'var(--radius-sm)',
              padding: '4px 8px',
              fontFamily: 'var(--font-mono)',
              fontSize: 10,
              color: 'var(--red)',
            }}
          />
        </div>

        <button 
          className="btn btn-primary" 
          onClick={handleInject}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, marginTop: 4 }}
        >
          <AlertTriangle size={12} /> Inject & Trigger Crash
        </button>
      </div>
    </div>
  );
};
